var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIniciarVideochamada = function SvgIniciarVideochamada(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 168,
    viewBox: "0 0 178 168",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Computador",
    d: "M29.3857 135.913C30.8155 131.997 35.5506 130.963 39.7229 130.967L66.5671 130.994L66.5674 114.431L12.0274 114.376C6.54756 114.37 2.10975 109.928 2.11524 104.453L2.22939 11.9809C2.23489 6.50627 6.68161 2.07263 12.1614 2.07813L151.045 2.13112C156.524 2.13662 160.838 6.57918 160.833 12.0538V93.0409H138.277C131.792 93.0192 109.32 93.0192 102.8 93.0409C99.2085 93.0538 94.6859 93.9229 91.0878 97.3779C87.4085 100.911 86.4128 105.483 86.4128 109.204V154.63C86.4128 155.01 86.4233 155.399 86.4459 155.796L36.0796 155.745C29.1941 155.738 24.419 148.898 26.7786 142.435L29.3857 135.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C\xC3\xA2mera",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.062 106.021C114.121 105.994 141.967 105.994 149.983 106.021C155.327 106.041 157.998 108.621 157.998 113.769V125.421L171.609 120.761C173.633 120.079 175.201 120.079 176.309 120.761C177.421 121.443 177.985 122.605 177.997 124.251V150.112C178.065 151.483 177.501 152.514 176.309 153.2C175.117 153.885 173.729 154.001 172.149 153.548L157.998 148.628V160.254C157.998 165.417 155.331 168.001 149.999 168.001H106.058C100.686 168.001 98.0025 165.421 98.0025 160.254V113.819C98.0025 108.64 100.69 106.041 106.062 106.021ZM114.001 148.632C111.334 148.605 110.002 149.891 110.002 152.487C110.002 155.082 111.334 156.38 114.001 156.38H130C132.668 156.38 134 155.082 134 152.487C134 149.891 132.668 148.605 130 148.632H114.001Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cidad\xC3\xA3o"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 246",
    cx: 86.926,
    cy: 50.3265,
    r: 22.3261,
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5233 82.5781C58.0828 82.5781 44.7551 95.9058 44.7551 112.346H84.5088C85.2409 106.78 86.8884 99.9291 90.2032 96.7462C95.0659 92.077 101.045 91.042 105.335 91.0266C108.521 91.016 114.271 91.0067 120.081 91.0024C114.719 85.7888 107.399 82.5781 99.33 82.5781H74.5233Z",
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.742 82.8992C99.8915 87.9791 93.7923 91.2603 86.9267 91.2603C80.0612 91.2603 73.962 87.979 70.1118 82.8992C71.5512 82.6854 73.0243 82.5746 74.5232 82.5746H99.3299C100.829 82.5746 102.302 82.6854 103.742 82.8992Z",
    fill: "#873D00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1142 4.92889e-06C5.49534 -0.00593104 0.121156 5.35049 0.11417 11.968L6.12961e-06 106.183C-0.00661869 112.801 5.35762 118.169 11.9773 118.175L64.4522 118.228L64.4519 128.914L39.677 128.889C37.4524 128.886 34.9359 129.156 32.7155 130.037C30.4714 130.928 28.3872 132.51 27.4073 135.162L24.8102 141.657L24.7888 141.715C21.9372 149.525 27.7108 157.793 36.0316 157.801H88.4321V110.391C88.4321 107.007 89.3368 103.067 92.4716 100.056C95.5429 97.1074 99.4592 96.3074 102.76 96.2956C109.275 96.2739 131.749 96.2739 138.229 96.2957H162.898V12.045C162.905 5.4482 157.638 0.0596761 150.997 0.0530066L12.1142 4.92889e-06ZM12.1107 9.09584C10.5054 9.09423 9.21158 10.3916 9.20999 11.9771L9.09584 106.192C9.09458 107.779 10.3835 109.078 11.9864 109.079L64.4517 109.132V109.067H80.6951C81.7163 106.127 83.4255 96.1325 86.1717 93.4956C91.5624 88.3194 98.1472 87.2163 102.727 87.1999C109.262 87.178 131.747 87.178 138.25 87.1999H153.88V12.038C153.881 10.4511 152.593 9.15139 150.991 9.14883L12.1107 9.09584Z",
    fill: "#C5D4FF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIniciarVideochamada, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iniciar-videochamada.71b6dfea.svg";
export { ForwardRef as ReactComponent };